import { useEffect, useState } from 'react';
import { API } from '../api';

import './Reserva.css';

function Reserva() {

  const [destinos, setDestinos] = useState([]);

  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    destino: '',
    fecha_viaje: '',
    personas: '',
    punto_embarque: '',
    mensaje: ''
  });

  useEffect(() => {
    window.scrollTo(0,0);
    API.get('destinos/')
      .then(res => setDestinos(res.data))
      .catch(err => console.error(err));
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await API.post('reservas/', formData);

      alert('✅ Reserva enviada correctamente');

      setFormData({
        nombre: '',
        email: '',
        telefono: '',
        destino: '',
        fecha_viaje: '',
        personas: '',
        punto_embarque: '',
        mensaje: ''
      });

    } catch (error) {
      console.error(error.response?.data || error);
      alert('❌ Error al enviar la reserva');
    }
  };

  return (
    <div className="reserva-page">

      <h1 className="reserva-title">Reserva tu viaje</h1>

      <p className="reserva-subtitle">
        Completa el formulario y nos pondremos en contacto contigo.
      </p>

      <div className="reserva-card">

        <form className="reserva-form" onSubmit={handleSubmit}>

          <input
            name="nombre"
            placeholder="Nombre completo"
            value={formData.nombre}
            onChange={handleChange}
            required
          />

          <input
            name="email"
            type="email"
            placeholder="Correo electrónico"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            name="telefono"
            placeholder="Número de teléfono / WhatsApp"
            value={formData.telefono}
            onChange={handleChange}
            required
          />

          <select
            name="destino"
            value={formData.destino}
            onChange={handleChange}
            required
          >
            <option value="">Selecciona un destino</option>

            {destinos.map(d => (
              <option key={d.id} value={d.id}>
                {d.nombre}
              </option>
            ))}

          </select>

          <input
            name="fecha_viaje"
            type="date"
            value={formData.fecha_viaje}
            onChange={handleChange}
            required
          />

          <input
            name="personas"
            type="number"
            min="1"
            placeholder="Número de personas"
            value={formData.personas}
            onChange={handleChange}
            required
          />

          <input
            name="punto_embarque"
            placeholder="Punto de embarque"
            value={formData.punto_embarque}
            onChange={handleChange}
            required
          />

          <textarea
            name="mensaje"
            placeholder="Mensaje adicional (opcional)"
            value={formData.mensaje}
            onChange={handleChange}
            rows="4"
          />

          <button type="submit" className="btn-primary">
            Enviar reserva
          </button>

        </form>

      </div>

    </div>
  );
}

export default Reserva;